import React from 'react';
import { Link } from 'react-router-dom';
import { DigitalEmployee } from '../types';
import { useCart } from '../context/CartContext';
import TeslaRobot from './TeslaRobot';

interface TeslaEmployeeCardProps {
  employee: DigitalEmployee;
  className?: string;
}

const TeslaEmployeeCard: React.FC<TeslaEmployeeCardProps> = ({
  employee,
  className = ''
}) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(employee, 1); // Default to 1 seat
  };
  // Generate a unique color for each robot based on employee ID
  const getUniqueColor = (id: string) => {
    // Simple hash function to generate a hue value (0-360)
    const hash = id.split('').reduce((acc, char) => {
      return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 100%, 70%)`;
  };

  const robotColor = getUniqueColor(employee.id);

  return (
    <div className={`tesla-employee-card ${className}`}>
      <div className="tesla-employee-avatar" style={{ '--robot-color': robotColor } as React.CSSProperties}>
        <TeslaRobot width={120} height={120} />
        <div className="avatar-glow"></div>
      </div>

      <div className="tesla-employee-info">
        <h3>{employee.name}</h3>
        <div className="model-number">Model T-{employee.id}00</div>
        <p>{employee.description}</p>

        <div className="tesla-employee-skills">
          {employee.skills.map((skill, index) => (
            <span key={index} className="tesla-skill-tag">
              {skill}
            </span>
          ))}
        </div>



        <div className="tesla-employee-actions">
          <Link to={`/chat/${employee.id}`} className="tesla-chat-button">
            <span className="button-icon">💬</span> Neural Chat
          </Link>
          <button onClick={handleAddToCart} className="tesla-cart-button">
            <span className="button-icon">🛒</span> Add to Cart
          </button>
          <Link to={`/employees`} className="tesla-details-button">
            <span className="button-icon">🔍</span> Specs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TeslaEmployeeCard;
